import { TFunction } from 'i18next';
import { BarcodeTypes } from '../../../../benefit/enums';
import { resources } from '../../../resources/resources';

export const nameField = 'name';
export const descriptionField = 'description';
export const brandDescriptionField = 'brandDescription';
export const addressField = 'address';
export const emailField = 'email';
export const phoneNumberField = 'phoneNumber';
export const websiteField = 'website';
export const howToOrderField = 'howToOrder';

export const getBarcodeTypeOptions = (translate: TFunction<'translate'>) => [
  {
    id: BarcodeTypes.Alphanumeric,
    text: translate(resources.codes.barcodeType.alphanumeric),
  },
  {
    id: BarcodeTypes.Code39,
    text: translate(resources.codes.barcodeType.barcode39),
  },
  {
    id: BarcodeTypes.Code128,
    text: translate(resources.codes.barcodeType.barcode128),
  },
  {
    id: BarcodeTypes.QR,
    text: translate(resources.codes.barcodeType.qr),
  },
];

export enum ProductContext {
  Add,
  Edit,
}

export const descriptionInitialValue = '<p></p>';
